import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'

// 获取任务管理
export function getDailyTask (data) {
  return axiosIns({
    url: `/api/pc/dailyTask/page`,
    owner: epmcore,
    method: 'get',
    params: data
  })
}

//获取整棵树包括人员
export function getTreeAndPerson () {
  return axiosIns({
    url: `/api/pc/organization/listDetail`,
    method: 'get',
    owner: epmcore
  })
}
function formatChildren (e) {
  let tree = []
  e.forEach(item => {
    tree.push(Object.assign(item, {
      label: item.name,
      key: item.id
    }))
  })
  return tree
}


export function formatTreeAndPerson (e) {
  let tree = []
  e.forEach((item) => {
    if (!item.mpttVOList && !item.data.employeeVOList) {
      /***
       * 不存在子部门&&没有子成员
       */
      tree.push({
        label: item.data.name,
        key: item.id || item.data.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: [],
        disabled: checkDisabled(item)
      })
    } else if (item.mpttVOList && !item.data.employeeVOList) {
      /***
       * 存在子部门&&没有子成员
       */
      tree.push({
        label: item.data.name,
        key: item.id || item.data.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatTreeAndPerson(item.mpttVOList),
        disabled: checkDisabled(item)
      })
    } else if (!item.mpttVOList && item.data.employeeVOList) {
      /***
       * 没有子部门 &&
       */
      tree.push({
        label: item.data.name,
        key: item.data.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatChildren(item.data.employeeVOList),
        disabled: checkDisabled(item)
      })
    } else if (item.mpttVOList && item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatTreeAndPerson(item.mpttVOList).concat(formatChildren(item.data.employeeVOList)),
        disabled: checkDisabled(item)
      })
    }
  })
  return tree
}

function checkDisabled (e) {
  // if (e) return true
  // else return false
  return false;
}

export function dictGet (params) {
  return axiosIns({
    url: `/api/pc/companyDict/getMap`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function dictPage (params) {
  return axiosIns({
    url: `/api/pc/companyDict/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/task-manage/taskAPI.js